import { motion } from 'framer-motion';
import { Users, Award, Shuffle } from 'lucide-react';
import { Badge } from '@/components/ui/badge';

const models = [
  { label: 'Prime', description: 'Lead contract execution with full accountability and program oversight.' },
  { label: 'Subcontractor', description: 'Augment prime teams with specialized capabilities and domain expertise.' },
  { label: 'Joint Venture', description: 'Strategic partnerships for large-scale programs and new market entry.' },
];

export default function Teaming() {
  return (
    <section
      id="teaming"
      data-testid="teaming-section"
      className="py-24 lg:py-32 bg-[#141414]"
    >
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16 items-start">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <p className="font-body text-[#B8102E] text-xs tracking-[0.3em] uppercase mb-4">
              Partnerships
            </p>
            <h2 className="font-heading text-3xl sm:text-4xl font-bold text-white tracking-tight mb-6">
              Teaming & Partnerships
            </h2>
            <div className="space-y-4 font-body text-[#A3A3A3] leading-relaxed">
              <p>
                Cole Utilities works alongside Cole Technologies, our Agile and staffing
                arm, to provide comprehensive solutions across the program lifecycle.
              </p>
              <p>
                We actively support minority, women, and veteran-owned business
                partnerships — expanding capacity while reinforcing commitment to
                diversity in federal contracting.
              </p>
            </div>

            <div className="mt-8 flex flex-wrap gap-2">
              <Badge className="bg-[#B8102E]/10 text-[#B8102E] border-[#B8102E]/30 hover:bg-[#B8102E]/20 font-body">
                <Users className="h-3 w-3 mr-1" /> Minority-Owned
              </Badge>
              <Badge className="bg-[#B8102E]/10 text-[#B8102E] border-[#B8102E]/30 hover:bg-[#B8102E]/20 font-body">
                <Award className="h-3 w-3 mr-1" /> Veteran-Owned
              </Badge>
              <Badge className="bg-[#B8102E]/10 text-[#B8102E] border-[#B8102E]/30 hover:bg-[#B8102E]/20 font-body">
                <Shuffle className="h-3 w-3 mr-1" /> Flexible Engagement
              </Badge>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="space-y-4"
          >
            <p className="font-body text-xs tracking-[0.2em] uppercase text-[#737373] mb-4">
              Engagement Models
            </p>
            {models.map((model, i) => (
              <div
                key={model.label}
                data-testid={`teaming-model-${i}`}
                className="p-6 bg-[#0A0A0A] border border-[#2A2A2A] rounded-lg hover:border-[#B8102E]/40 transition-all duration-300"
              >
                <h3 className="font-heading text-lg font-semibold text-white mb-1">
                  {model.label}
                </h3>
                <p className="font-body text-sm text-[#A3A3A3]">
                  {model.description}
                </p>
              </div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
}
